import { useState, useEffect } from "react";
import { Drop } from "../types";
import { FONTS } from "../data/affirmations";
import { Confetti } from "./Confetti";

interface WalkCompleteProps {
  drop: Drop;
  walkTime: number;
  steps: number;
  onDone: () => void;
}

export function WalkComplete({ drop, walkTime, steps, onDone }: WalkCompleteProps) {
  const [showConfetti, setShowConfetti] = useState(true);
  const [copied, setCopied] = useState(false);
  const miles = (steps * 0.00047).toFixed(2);

  const fmt = (s: number) =>
    `${Math.floor(s / 60).toString().padStart(2, "0")}:${(s % 60).toString().padStart(2, "0")}`;

  useEffect(() => {
    const t = setTimeout(() => setShowConfetti(false), 4000);
    return () => clearTimeout(t);
  }, []);

  const shareText = `just completed ${drop.title} on Hot Girl Walk 🚶‍♀️✨\n${miles} miles · ${steps.toLocaleString()} steps · ${fmt(walkTime)}\n\nwalking the streets my faves walked 💕 hotgirlwalks.com\n\n#HotGirlWalk #London #${drop.title.replace(/\s/g, "")}`;

  const copyToClipboard = () => {
    navigator.clipboard.writeText(shareText).then(() => {
      setCopied(true);
      setTimeout(() => setCopied(false), 3000);
    });
  };

  return (
    <div style={{ minHeight: "100vh", background: "#FAF7F4", display: "flex", flexDirection: "column" }}>
      <style>{FONTS + `
        @keyframes popIn { 0% { transform:scale(0.5);opacity:0 } 70% { transform:scale(1.1) } 100% { transform:scale(1);opacity:1 } }
        @keyframes fadeUp { from { opacity:0;transform:translateY(20px) } to { opacity:1;transform:translateY(0) } }
      `}</style>

      {showConfetti && <Confetti />}

      {/* Header */}
      <div style={{ background: `linear-gradient(160deg,${drop.cardBg},#FFF8F0)`, padding: "52px 24px 36px", textAlign: "center", borderBottomLeftRadius: "32px", borderBottomRightRadius: "32px" }}>
        <div style={{ fontSize: "80px", animation: "popIn 0.6s ease", marginBottom: "12px" }}>🎉</div>
        <div style={{ fontSize: "11px", letterSpacing: "4px", color: drop.accentColor, textTransform: "uppercase", marginBottom: "4px", fontFamily: "'DM Sans',sans-serif", fontWeight: 700 }}>walk complete</div>
        <h1 style={{ fontFamily: "'Playfair Display',serif", fontStyle: "italic", fontWeight: 900, fontSize: "36px", color: "#1a1a1a", letterSpacing: "-1px", lineHeight: 1, marginBottom: "6px" }}>{drop.title}</h1>
        <p style={{ fontFamily: "'DM Sans',sans-serif", fontSize: "14px", color: "#999", margin: 0 }}>You actually did it. That's a slay. 💅</p>
      </div>

      <div style={{ padding: "24px 20px 40px", maxWidth: "480px", margin: "0 auto", width: "100%", animation: "fadeUp 0.5s 0.3s ease both" }}>

        {/* Stats */}
        <div style={{ background: "#fff", borderRadius: "24px", padding: "24px", marginBottom: "16px", border: "1px solid #EDE8E3", boxShadow: "0 4px 24px rgba(0,0,0,0.06)" }}>
          <div style={{ display: "grid", gridTemplateColumns: "1fr 1fr 1fr", gap: "16px", textAlign: "center" }}>
            {[
              { val: fmt(walkTime), label: "Time", color: "#1a1a1a" },
              { val: steps.toLocaleString(), label: "Steps", color: "#C9184A" },
              { val: `${miles}mi`, label: "Miles", color: "#0A7C5E" },
            ].map(s => (
              <div key={s.label}>
                <div style={{ fontFamily: "'Playfair Display',serif", fontWeight: 900, fontSize: "28px", color: s.color, lineHeight: 1 }}>{s.val}</div>
                <div style={{ fontSize: "10px", color: "#bbb", letterSpacing: "2px", textTransform: "uppercase", fontFamily: "'DM Sans',sans-serif", marginTop: "4px" }}>{s.label}</div>
              </div>
            ))}
          </div>
        </div>

        {/* Share */}
        <div style={{ background: "#fff", border: "1px solid #EDE8E3", borderRadius: "20px", padding: "20px", marginBottom: "16px" }}>
          <div style={{ fontSize: "11px", color: "#bbb", letterSpacing: "3px", textTransform: "uppercase", marginBottom: "14px", fontFamily: "'DM Sans',sans-serif" }}>Share your walk 📱</div>
          <div style={{ background: "#FAF7F4", borderRadius: "14px", padding: "14px", marginBottom: "14px", fontFamily: "'DM Sans',sans-serif", fontSize: "13px", color: "#666", lineHeight: 1.7, fontStyle: "italic" }}>
            {shareText.split("\n").map((line, i) => <div key={i}>{line || <br />}</div>)}
          </div>
          <div style={{ display: "grid", gridTemplateColumns: "1fr 1fr", gap: "10px" }}>
            <button
              onClick={copyToClipboard}
              style={{ padding: "13px", borderRadius: "14px", border: "none", cursor: "pointer", background: "#000", color: "#fff", fontSize: "13px", fontWeight: 700, fontFamily: "'DM Sans',sans-serif", display: "flex", alignItems: "center", justifyContent: "center", gap: "8px" }}>
              <svg width="16" height="16" viewBox="0 0 24 24" fill="white">
                <path d="M19.59 6.69a4.83 4.83 0 01-3.77-4.25V2h-3.45v13.67a2.89 2.89 0 01-2.88 2.5 2.89 2.89 0 01-2.89-2.89 2.89 2.89 0 012.89-2.89c.28 0 .54.04.79.1V9.01a6.33 6.33 0 00-.79-.05 6.34 6.34 0 00-6.34 6.34 6.34 6.34 0 006.34 6.34 6.34 6.34 0 006.33-6.34V8.69a8.18 8.18 0 004.78 1.53V6.78a4.85 4.85 0 01-1.01-.09z"/>
              </svg>
              TikTok
            </button>
            <button
              onClick={copyToClipboard}
              style={{ padding: "13px", borderRadius: "14px", border: "none", cursor: "pointer", background: "linear-gradient(135deg,#833ab4,#fd1d1d,#fcb045)", color: "#fff", fontSize: "13px", fontWeight: 700, fontFamily: "'DM Sans',sans-serif", display: "flex", alignItems: "center", justifyContent: "center", gap: "8px" }}>
              <svg width="16" height="16" viewBox="0 0 24 24" fill="white">
                <path d="M12 2.163c3.204 0 3.584.012 4.85.07 3.252.148 4.771 1.691 4.919 4.919.058 1.265.069 1.645.069 4.849 0 3.205-.012 3.584-.069 4.849-.149 3.225-1.664 4.771-4.919 4.919-1.266.058-1.644.07-4.85.07-3.204 0-3.584-.012-4.849-.07-3.26-.149-4.771-1.699-4.919-4.92-.058-1.265-.07-1.644-.07-4.849 0-3.204.013-3.583.07-4.849.149-3.227 1.664-4.771 4.919-4.919 1.266-.057 1.645-.069 4.849-.069zM12 0C8.741 0 8.333.014 7.053.072 2.695.272.273 2.69.073 7.052.014 8.333 0 8.741 0 12c0 3.259.014 3.668.072 4.948.2 4.358 2.618 6.78 6.98 6.98C8.333 23.986 8.741 24 12 24c3.259 0 3.668-.014 4.948-.072 4.354-.2 6.782-2.618 6.979-6.98.059-1.28.073-1.689.073-4.948 0-3.259-.014-3.667-.072-4.947-.196-4.354-2.617-6.78-6.979-6.98C15.668.014 15.259 0 12 0zm0 5.838a6.162 6.162 0 100 12.324 6.162 6.162 0 000-12.324zM12 16a4 4 0 110-8 4 4 0 010 8zm6.406-11.845a1.44 1.44 0 100 2.881 1.44 1.44 0 000-2.881z"/>
              </svg>
              Instagram
            </button>
          </div>
          {copied && (
            <div style={{ textAlign: "center", marginTop: "10px", fontSize: "13px", color: "#0A7C5E", fontFamily: "'DM Sans',sans-serif", fontWeight: 600 }}>
              ✅ Copied! Paste into TikTok or Instagram 💕
            </div>
          )}
        </div>

        <button
          onClick={onDone}
          style={{ width: "100%", padding: "16px", borderRadius: "16px", border: "none", cursor: "pointer", background: "#1a1a1a", color: "#fff", fontSize: "14px", fontWeight: 700, letterSpacing: "1.5px", textTransform: "uppercase", fontFamily: "'DM Sans',sans-serif", boxShadow: "0 6px 20px rgba(0,0,0,0.18)" }}>
          Back to Drops 💕
        </button>
      </div>
    </div>
  );
}
